export default {
  accountInfo: {},
  logged: false
}



// WEBPACK FOOTER //
// ./src/components/account/store/state.js